import React from "react";
import { cn } from "../../../common/u1/cn";

/* "Total ownership · 93% · 7% free". */
export const OwnershipMeter = ({ total = 0, pending = 0, className = "" }) => {
  const committed = Math.max(0, Math.min(100, total));
  /* An edit reclaims its own share, so the caller passes a `total` that has
     already had it removed; `pending` is what the field currently says. */
  const proposed = Math.max(0, Math.min(100 - committed, pending));
  const combined = parseFloat((committed + proposed).toFixed(2));
  const free = parseFloat((100 - combined).toFixed(2));
  const over = total + pending > 100;

  return (
    <div
      className={cn(
        "rounded-[10px] border border-[var(--field-inset-border)] bg-[var(--field-inset)] px-3.5 py-3",
        className
      )}
    >
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <span className="text-[12.5px] font-semibold text-[var(--ink-2)] font-sans">
          Total ownership
        </span>
        <span className="text-[12.5px] font-bold text-[var(--ink)] font-mono">
          {combined}% <span className="text-[var(--muted-2)]">·</span>{" "}
          <span className={over ? "text-[var(--coral-deep)]" : "text-[var(--muted)]"}>
            {free}% free
          </span>
        </span>
      </div>

      <div
        aria-hidden="true"
        className="mt-2 flex h-[6px] w-full overflow-hidden rounded-full bg-[var(--line)]"
      >
        {/* Widths are data, so they cannot be Tailwind classes. */}
        <span
          className="h-full bg-[var(--navy)]"
          style={{ width: `${committed}%` }}
        />
        <span
          className="h-full bg-[var(--warning)] transition-[width] duration-150"
          style={{ width: `${proposed}%` }}
        />
      </div>

      <p
        className={cn(
          "m-0 mt-2 text-[11.5px] font-sans",
          over ? "text-[var(--coral-deep)]" : "text-[var(--muted)]"
        )}
      >
        {over
          ? "That is more than 100% between all owners."
          : free === 0
          ? "All shares are allocated."
          : `${free}% of shares still unallocated.`}
      </p>
    </div>
  );
};

export default OwnershipMeter;
